import { render } from "./ComponenteGasPreciosHistoricos.vue?vue&type=template&id=5343f94a&scoped=true"
import script from "./ComponenteGasPreciosHistoricos.vue?vue&type=script&lang=js"
export * from "./ComponenteGasPreciosHistoricos.vue?vue&type=script&lang=js"

import "./ComponenteGasPreciosHistoricos.vue?vue&type=style&index=0&id=5343f94a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5343f94a"]])

export default __exports__